function TimeSpan(str) {
    this.seconds = 0;

    this.parse = function (val) {
        if (typeof val == 'number') {
            this.seconds = val;

        } else if (typeof val == 'string') {
            // Timespans should be in the format 'd.hh:mm:ss'.
            var parts = val.split(':');

            this.seconds = parseInt(parts[2]);
            this.seconds += parseInt(parts[1]) * 60;

            // the 'd.' is optional.
            parts = parts[0].split('.');
            if (parts.length == 2) {
                this.seconds += parseInt(parts[1]) * 3600;
                this.seconds += parseInt(parts[0]) * 86400;
            } else {
                this.seconds += parseInt(parts[0]) * 3600;
            }
        }
    };

    this.toFriendly = function () {
        var interval;
        var num = this.seconds;

        if (this.seconds % 60 != 0) {
            interval = 'second';

        } else if (this.seconds % 3600 != 0) {
            interval = 'minute';
            num = num / 60;

        } else if (this.seconds % 86400 != 0) {
            interval = 'hour';
            num = num / 3600;

        } else {
            interval = 'day';
            num = num / 86400;
        }

        if (Math.abs(num) != 1) {
            interval += 's'
        }

        return num + ' ' + interval;
    };

    this.fromSeconds = function (val) {
        this.seconds = val;
    };

    this.totalSeconds = function () {
        return this.seconds;
    };

    this.getParts = function () {
        var parts = {};

        var num = this.seconds;
        parts.seconds = num % 60;

        num = (num - parts.seconds) / 60;
        parts.minutes = num % 60;

        num = (num - parts.minutes) / 60;
        parts.hours = num % 24;

        parts.days = (num - parts.hours) / 24;

        return parts;
    };


    this.toString = function () {
        var parts = this.getParts();

        var str = pad(parts.hours) + ':' + pad(parts.minutes) + ':' + pad(parts.seconds % 60);

        if (parts.days != 0) {
            str = parts.days + '.' + str;
        }

        return str;
    };

    function pad(num) {
        var s = "0" + num;
        return s.substr(s.length - 2);
    }

    if (str) {
        this.parse(str);
    }
}

(function ($) {
    var intervals = [
        'Minutes',
        'Hours',
        'Days'
    ];

    var defaults = {
        dropDirection: 'down'
    };

    function timeSpan(elm, opts) {
        // public methods
        this.init = init;
        this.val = val;
        this.destroy = destroy;

        var group;
        var num;
        var btn;
        var interval;
        var config = $.extend(defaults, opts);

        function init() {
            elm.hide();

            group = $('<div class="input-group input-append">').insertAfter(elm);

            num = $('<input type="number" class="col-2 form-control">')
                .on('change', change)
                .appendTo(group);

            var btnGroup = $('<div class="btn-group input-group-btn">')
                .addClass(config.dropDirection == 'up' ? 'dropup' : 'dropdown')
                .appendTo(group);

            btn = $('<button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">')
                .appendTo(btnGroup);

            var dropdownMenu = $('<div class="dropdown-menu dropdown-menu-right">')
                .appendTo(btnGroup);

            $.each(intervals, function (i, val) {
                $('<a class="dropdown-item" href="#">')
                    .appendTo(dropdownMenu)
                    .text(val)
                    .on('click', function () {
                        setInterval(val);
                        change();
                    });
            });

            val(elm.val());
        }

        function val(val) {
            var seconds = new TimeSpan(val).totalSeconds();
            
            if (seconds % 3600 != 0) {
                setInterval('Minutes');
                num.val(seconds / 60);

            } else if (seconds % 86400 != 0) {
                setInterval('Hours');
                num.val(seconds / 3600);

            } else {
                setInterval('Days');
                num.val(seconds / 86400);
            }
        }

        function setInterval(value) {
            interval = value;
            btn.html(value + ' <span class="caret"></span>');
        }

        function change() {
            elm.val(new TimeSpan(getTotalMinutes() * 60).toString()).change();
        }

        function getTotalMinutes() {
            var val = num.val();
            if (!val) {
                return 0;
            }

            var int = parseInt(val);

            switch (interval) {
                case 'Minutes': return int;
                case 'Hours': return int * 60;
                case 'Days': return int * 1440;
            }
        }

        function destroy() {
            group.remove();
            elm.show();
        }

        init();
    }

    $.fn.chTimeSpan = function (method) {
        if (this.timeSpan) {
            this.timeSpan[method].apply(this.timeSpan, [].slice.call(arguments, 1));
        } else {
            this.timeSpan = new timeSpan($(this), method);
        }
        return this;
    };
}($));
